export const GET_ALL_EXERCISES_REQUEST = 'GET_ALL_EXERCISES_REQUEST';
export const GET_ALL_EXERCISES_SUCCESS = 'GET_ALL_EXERCISES_SUCCESS';
export const GET_ALL_EXERCISES_FAILED = 'GET_ALL_EXERCISES_FAILED';

export const GET_MORE_EXERCISES_REQUEST = 'GET_MORE_EXERCISES_REQUEST';
export const GET_MORE_EXERCISES_SUCCESS = 'GET_MORE_EXERCISES_SUCCESS';
export const GET_MORE_EXERCISES_FAILED = 'GET_MORE_EXERCISES_FAILED';

export const GET_RECENT_EXERCISES_REQUEST = 'GET_RECENT_EXERCISES_REQUEST';
export const GET_RECENT_EXERCISES_SUCCESS = 'GET_RECENT_EXERCISES_SUCCESS';
export const GET_RECENT_EXERCISES_FAILED = 'GET_RECENT_EXERCISES_FAILED';

export const GET_MORE_RECENT_EXERCISES_REQUEST = 'GET_MORE_RECENT_EXERCISES_REQUEST';
export const GET_MORE_RECENT_EXERCISES_SUCCESS = 'GET_MORE_RECENT_EXERCISES_SUCCESS';
export const GET_MORE_RECENT_EXERCISES_FAILED = 'GET_MORE_RECENT_EXERCISES_FAILED';

export const GET_EXERCISES_BY_TYPE_REQUEST = 'GET_EXERCISES_BY_TYPE_REQUEST';
export const GET_EXERCISES_BY_TYPE_SUCCESS = 'GET_EXERCISES_BY_TYPE_SUCCESS';
export const GET_EXERCISES_BY_TYPE_FAILED = 'GET_EXERCISES_BY_TYPE_FAILED';

export const GET_MORE_EXERCISES_BY_TYPE_REQUEST = 'GET_MORE_EXERCISES_BY_TYPE_REQUEST';
export const GET_MORE_EXERCISES_BY_TYPE_SUCCESS = 'GET_MORE_EXERCISES_BY_TYPE_SUCCESS';
export const GET_MORE_EXERCISES_BY_TYPE_FAILED = 'GET_MORE_EXERCISES_BY_TYPE_FAILED';

export const NO_MORE_EXERCISES = 'NO_MORE_EXERCISES';
export const NO_MORE_EXERCISES_BY_TYPE = 'NO_MORE_EXERCISES_BY_TYPE';

export const EXERCISE_SCROLL_TYPES = {
    ALL: 'ALL_EXERCISES',
    BY_TYPE: 'BY_TYPE_EXERCISES',
};



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/ExercisesActionTypes.js